import "./sweetSmoke.scss";
import "../perfume.scss";

// Images
import MainImage from "../../../assets/img/perfume/sweet_smoke_main.webp";
import ConcentrationImage from "../../../assets/img/perfume/sweet_smoke_concentration.webp";
import Ingredients1 from "../../../assets/img/perfume/ingredients/almond.webp";
import Ingredients2 from "../../../assets/img/perfume/ingredients/coffee-beans.webp";
import Ingredients3 from "../../../assets/img/perfume/ingredients/lemon.webp";
import Ingredients4 from "../../../assets/img/perfume/ingredients/sandalwood.webp";
import Ingredients5 from "../../../assets/img/perfume/ingredients/jasmine.webp";
import Ingredients6 from "../../../assets/img/perfume/ingredients/tuberose.webp";
import Ingredients7 from "../../../assets/img/perfume/ingredients/cacao.webp";
import Ingredients8 from "../../../assets/img/perfume/ingredients/textured-driftwood-with.webp";
import Details from "../components/details/Details";
import productStore from "../../../store/productStore";
import { useEffect, useState } from "react";
import ProductReview from "../components/productReview/ProductReview";
import ProductSlider from "../components/productSlider/ProductSlider";
import Ingredients from "../components/ingredients/Ingredients";
import FirstContent from "../components/firstContent/FirstContent";
import Concentration from "../components/concentration/Concentration";
import SEO from "components/seo/SEO";
import { SWEET_SMOKE_ID } from "../../../constant";

import MainVideoWEBM from "assets/video/perfume/sweet_smoke/sweet_smoke_web.webm";
// import MainVideoMobWEBM from "assets/video/perfume/sweet_smoke/sweet_smoke_mob.webm";
import MainVideoMobWEBM from "assets/video/perfume/sweet_smoke/sweet_smoke_mobBG.webm";
import sliderImage1 from "assets/img/perfume/slider/posttrioswipe1ss.webp";
import sliderImage2 from "assets/img/perfume/slider/posttrioswipe2ss.webp";
import VideoWithEndImageNew from "../components/videoWithEndImage/VideoWithEndImageNew";
import ProductSliderNew from "../components/productSlider/ProductSliderNew";
import imageLoadStore from "store/imageLoadStore";
import MyLoader from "components/myLoader/MyLoader";

const SweetSmoke = () => {
  const ImageLoadStore = imageLoadStore();
  const ProductStore = productStore();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const AccordionDetails = [
    {
      label: "DESCRIPTION",
      content: (
        <div>
          A bold and sensual gourmand fragrance that blends sweetness with smoky
          depth. Sweet Smoke opens with almond, coffee, lemon, and bergamot for
          a rich yet vibrant start. The floral heart adds softness through
          jasmine, tuberose, rose, and orris. The base is deeply indulgent —
          cacao, vanilla, praline, sandalwood, patchouli, amber, and cinnamon
          create a warm, long-lasting finish.
          <br />
          <br />
          Intense, addictive, and unforgettable.
        </div>
      ),
    },
    {
      label: "FRAGRANCE NOTES",
      content: (
        <p>
          <strong>Top Notes: </strong>Almond, Coffee, Lemon, Bergamot
          <br />
          <strong>Middle Notes: </strong>Jasmine Sambac, Tuberose, Orange
          Blossom, Bulgarian Rose, Orris
          <br />
          <strong>Base Notes: </strong>Cacao, Tonka Bean, Vanilla, Praline,
          Sandalwood, Cedarwood, Cinnamon, Patchouli, Amber
        </p>
      ),
    },
    {
      label: "FEELINGS",
      content: <p>Intense • Sensual • Warm • Luxurious • Addictive</p>,
    },
    {
      label: "OCCASIONS",
      content: (
        <ol>
          <li>Evening Wear</li>
          <li>Special Events</li>
          <li>Winter Nights</li>
          <li>Romantic Occasions</li>
        </ol>
      ),
    },
    {
      label: "BEHIND THE PERFUME",
      content: (
        <p>
          Sweet Smoke is crafted for those who love rich, sweet, and dark
          fragrances. The gourmand base creates a powerful trail, while florals
          keep it balanced and elegant.
        </p>
      ),
    },
    {
      label: "SHIPPING & RETURN",
      content: (
        <p>
          We carefully pack and dispatch all orders to ensure safe delivery.
          Orders are processed within standard business timelines.
          <br />
          <strong>Please note:</strong> Due to hygiene and product safety
          reasons, we do not accept returns or exchanges once the product has
          been delivered.
        </p>
      ),
    },
    {
      label: "LEGAL INFORMATION",
      content: (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div>
            <p style={{ fontWeight: 700 }}>Marketed by KRISTIVE</p>
            <p>
              105, Shubham Residency 1, Navagam Surat 394210, Gujarat, India
            </p>
          </div>
          <div>
            <p>
              <strong>Customer Care:</strong>
            </p>
            <p>
              <strong>Email</strong> - support@kristive.com
            </p>
            <p>
              <strong>Call</strong> - +91 81601 92573
            </p>
            <p>
              <strong>Website</strong> - www.kristive.com
            </p>
          </div>
          <div>
            <p>
              <strong>Manufactured by</strong>
            </p>
            <p>
              MINATI ESSENTIALS 8, Laxmi Narayan Industries, Udhna Surat,
              Gujarat - 394210
            </p>
            <strong>Lic. No.: </strong>GC/2055
          </div>
          <div>
            <p>
              <strong>Country of Origin:</strong> India
            </p>
            <p>
              <strong>Net Contents:</strong> 50ML / 1.7 fl. oz
            </p>
          </div>
          <div>
            <p>
              <strong>Ingredients:</strong>
            </p>
            <p>
              Linalool, Geraniol, Limonene, Eugenol, Denatured Ethyl Alcohol,
              Fragrance Oil.
            </p>
          </div>

          <div>
            <p>For External Use Only.</p>
            <p>Store in a Cool & Dry Place.</p>
          </div>

          <div>
            <p>
              <strong>Usage:</strong>
            </p>
            <p>
              To avoid staining, spray perfume from a safe distance of 15-20 cm.
            </p>
          </div>
          <div>
            <p>
              <strong>Warning:</strong>
            </p>
            <p>Keep away from children and pets.</p>
            <p>Avoid contact with eyes, mouth, and broken skin.</p>
            <p>Flammable - Keep away from heat, sparks, and open flame.</p>
          </div>

          <div>
            <p>
              <strong>Generic Name:</strong> Perfume
            </p>
            <p>Best Before: 36 months from manufacturing date.</p>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0 });
    fetchSpecificProductRating();
    if (ImageLoadStore.imageLoading) {
      setTimeout(() => {
        document.body.style.overflowY = "hidden";
      }, 50);
    }
  }, []);

  const fetchSpecificProductRating = async () => {
    setIsLoading(true);
    const product = await ProductStore.fetchOneProduct({
      _id: SWEET_SMOKE_ID,
    });
    setProduct(product);
    setIsLoading(false);
  };

  return (
    <>
      <SEO
        title="Sweet Smoke Perfume | Bold Sweet Gourmand Smoky Fragrance"
        description="Sweet Smoke is an intense gourmand perfume with coffee, cacao, vanilla, and amber. A sensual, long-lasting fragrance made for bold evening wear."
      />
      {ImageLoadStore.imageLoading && (
        <div className="loading">
          <MyLoader height="100vh" />
        </div>
      )}
      <div className="perfume-details sweet-smoke">
        <VideoWithEndImageNew
          websiteVideoWEBM={MainVideoWEBM}
          mobileVideoWEBM={MainVideoMobWEBM}
          product={product}
          slogan="Where Sweetness Meets Seduction."
        />
        <ProductSliderNew images={[sliderImage1, sliderImage2]} />

        <div className="content">
          {/* <FirstContent
            title={"SWEET SMOKE"}
            shortDescription={"Sweet. Warm. Addictive."}
            image={MainImage}
            id={SWEET_SMOKE_ID}
            productName={product?.productName || ""}
            regularPrice={product?.regularPrice || ""}
            salePrice={product?.salePrice || null}
          />

          {product?.productImages.length > 0 && (
            <ProductSlider images={product?.productImages || []} />
          )} */}

          <Ingredients
            Ingredients1={{
              img: Ingredients1,
              name: "Almond",
              desc: "Sweet, nutty warmth adding a soft gourmand touch",
            }}
            Ingredients2={{
              img: Ingredients2,
              name: "Coffee",
              desc: "Deep, roasted richness with bold addictive intensity",
            }}
            Ingredients3={{
              img: Ingredients3,
              name: "Lemon",
              desc: "Zesty citrus spark that brightens the composition",
            }}
            Ingredients4={{
              img: Ingredients4,
              name: "Sandalwood",
              desc: "Smooth woody base with creamy, long-lasting warmth",
            }}
            Ingredients5={{
              img: Ingredients5,
              name: "Jasmine Sambac",
              desc: "Opulent, sweet floral with exotic sensual depth",
            }}
            Ingredients6={{
              img: Ingredients6,
              name: "Tuberose",
              desc: "Creamy white floral with a rich, intoxicating allure",
            }}
            Ingredients7={{
              img: Ingredients7,
              name: "Cacao",
              desc: "Dark chocolate richness with a warm indulgent feel",
            }}
            Ingredients8={{
              img: Ingredients8,
              name: "Bergamot",
              desc: "Fresh citrus elegance with a subtle floral twist",
            }}
          />

          <Concentration
            image={ConcentrationImage}
            percentage={25}
            shortDescription={
              "Elegant Blend of Fruity Freshness and Deep Floral Richness"
            }
          />

          <Details items={AccordionDetails} />

          <ProductReview
            isLoading={isLoading}
            averageRating={product?.averageRating || 0}
            totalReview={product?.ratingCount || 0}
            ratings={product?.ratings || []}
            particularRatings={{
              fiveStar: product?.fiveStar,
              fourStar: product?.fourStar,
              threeStar: product?.threeStar,
              twoStar: product?.twoStar,
              oneStar: product?.oneStar,
            }}
            appBarColor="#333a2c"
          />
        </div>
      </div>
    </>
  );
};

export default SweetSmoke;
